import { buildProps } from '@sgui-plus/utils/props'
import { componentSizes } from '@sgui-plus/utils/size'
import { isNumber } from '@sgui-plus/utils/util'

export const inputNumberProps = buildProps({
  step: {
    type: Number,
    default: 1,
  },
  stepStrictly: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: Number,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    values: componentSizes,
  },
  class: {
    type: String
  },
  controls: {
    type: Boolean,
    default: true,
  },
  closable: {
    type: Boolean,
    default: false,
  },
  controlsPosition: {
    type: String,
    default: '',
    values: ['', 'right'],
  },
  valueOnClear: {
    type: [String, Number, null],
    validator: (val: 'min' | 'max' | number | null) =>
      val === null || isNumber(val) || ['min', 'max'].includes(val),
    default: null,
  },
  precision: {
    type: Number,
    validator: (val: number) => val >= 0 && val === parseInt(`${val}`, 10),
  },
  validateEvent: {
    type: Boolean,
    default: true,
  },
} as const)

export const inputNumberEmits = {
  onChange: (prev: number | undefined, cur: number | undefined) => prev !== cur,
  onDown: (prev: number | undefined, cur: number | undefined) => prev !== cur,
  onUp: (prev: number | undefined, cur: number | undefined) => prev !== cur,
  onInput: (val: number | null | undefined) => isNumber(val),
  onBlur: (e: FocusEvent) => e instanceof FocusEvent,
  onFocus: (e: FocusEvent) => e instanceof FocusEvent,
  'update:modelValue': (val: number | undefined) =>
    isNumber(val) || val === undefined,
  onClear: () => true
}
